<script setup lang="ts">
defineOptions({
	name: 'ConfigureSection',
})

const { t: $t } = useI18n()

const firstHtml = computed(() => {
	return $t(
		'At any time and free of charge, you may configure the cookies collected and used via the following {link}. Alternatively, you can also configure cookies through your browser, allowing you to permit, block, or delete installed cookies. Please note that, while you may retain only the necessary cookies to use or browse the Platform, disabling other cookies may limit your access to all the features we provide. The {help} button on your browser will provide additional information on how to configure your browser.',
		{
			help: `<span class="italic">"${$t('Help')}"</span>`,
			link: `<a href="https://www.cookieyes.com/knowledge-base/cookie-consent/what-is-opt-out-consent/" target="_blank" class="underline text-sky-700">${$t('link')}</a>`,
		},
	)
})
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:settings-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('How can I revoke, configure, or reject the collection and use of cookies') }}?
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p v-html="firstHtml"></p>
			<p>
				{{
					$t(
						'If you choose to reject the installation of cookies, you may continue to use the Platform, but some services may be limited, and navigation usability may be diminished (e.g., with respect to preference cookies). All your preferences will be stored until you decide to make further changes',
					)
				}}.
			</p>
		</div>
	</section>
</template>
